import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import ShareIcon from "@mui/icons-material/Share";
import { toast } from "react-toastify";

export default function MessageActions({ message, onCopy, onDelete, onEdit, onRegenerate, isUserMessage }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopy = () => {
    if (onCopy) {
      onCopy(message.content);
    } else {
      navigator.clipboard.writeText(message.content);
      toast.success("Message copied to clipboard!");
    }
    handleClose();
  };

  const handleDelete = () => {
    if (window.confirm("Delete this message?")) {
      if (onDelete) {
        onDelete();
      }
      toast.success("Message deleted");
    }
    handleClose();
  };

  const handleEdit = () => {
    if (onEdit) {
      onEdit();
    }
    handleClose();
  };

  const handleRegenerate = () => {
    if (onRegenerate) {
      onRegenerate();
    }
    handleClose();
  };

  const handleShare = async () => {
    const text = message.content || "";
    try {
      // Try native share if available
      if (navigator.share) {
        await navigator.share({
          title: "Share from exivis",
          text,
        });
      } else {
        await navigator.clipboard.writeText(text);
        toast.success("Link copied to clipboard!");
      }
    } catch (err) {
      console.error("Share failed:", err);
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <Tooltip title="More actions">
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            color: "#60a5fa",
            bgcolor: "rgba(29, 78, 216, 0.2)",
            border: "1px solid rgba(59, 130, 246, 0.3)",
            transition: "all 0.2s",
            opacity: 1,
            "&:hover": { 
              color: "#bfdbfe",
              bgcolor: "rgba(29, 78, 216, 0.35)",
              borderColor: "rgba(59, 130, 246, 0.5)",
              transform: "scale(1.1)",
            },
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0c4a6e, #075985)",
            color: "white",
            border: "1px solid rgba(59, 130, 246, 0.3)",
            minWidth: 180,
            boxShadow: "0 4px 12px rgba(29, 78, 216, 0.3)",
          },
        }}
      >
        <MenuItem onClick={handleCopy} sx={{ fontSize: "0.875rem", py: 1 }}>
          <ContentCopyIcon sx={{ mr: 1.5, fontSize: "1.1rem" }} />
          Copy
        </MenuItem>
        <MenuItem onClick={handleShare} sx={{ fontSize: "0.875rem", py: 1 }}>
          <ShareIcon sx={{ mr: 1.5, fontSize: "1.1rem" }} />
          Share
        </MenuItem>
        {isUserMessage && (
          <MenuItem onClick={handleEdit} sx={{ fontSize: "0.875rem", py: 1 }}>
            <EditIcon sx={{ mr: 1.5, fontSize: "1.1rem" }} />
            Edit
          </MenuItem>
        )}
        {!isUserMessage && (
          <MenuItem onClick={handleRegenerate} sx={{ fontSize: "0.875rem", py: 1 }}>
            <RefreshIcon sx={{ mr: 1.5, fontSize: "1.1rem" }} />
            Regenerate
          </MenuItem>
        )}
        <MenuItem
          onClick={handleDelete}
          sx={{ fontSize: "0.875rem", py: 1, color: "#ef4444" }}
        >
          <DeleteOutlineIcon sx={{ mr: 1.5, fontSize: "1.1rem" }} />
          Delete
        </MenuItem>
      </Menu>
    </>
  );
}


